import React, { useEffect, useState } from "react";
import { Button, Card, Spinner } from "react-bootstrap";
import { BsBuilding, BsCalendar3, BsCheckCircle, BsClock, BsFingerprint, BsHeartPulse, BsPersonBadge } from "react-icons/bs";
import { useNavigate } from "react-router-dom";
import BottomNavbar from "../components/BottomNavbar";
import { checkJadwal, fetchJadwalHariIni } from "../services/jadwalService";
import { fetchNamaGuru } from "../services/akunService";
import { kirimPresensiHadir } from "../services/presensiService";
import logo from "../assets/EPRAJOGO1.png";

const cardStyle = {
  border: "1px solid var(--app-border)",
  borderRadius: 18,
  boxShadow: "0 4px 14px #102e500d",
};

function Dashboard() {
  const now = new Date();
  const hariTanggal = now.toLocaleDateString("id-ID", {
    weekday: "long", day: "numeric", month: "long", year: "numeric",
  });
  const navigate = useNavigate();
  const [jadwal, setJadwal] = useState(null);
  const [namaSiswa, setNamaSiswa] = useState("");
  const [kelas, setKelas] = useState("");
  const [namaGuru, setNamaGuru] = useState("-");
  const [isPresensiLoading, setIsPresensiLoading] = useState(false);
  const [notice, setNotice] = useState(null);

  const handlePresensi = async () => {
    if (!window.confirm("Kamu yakin ingin presensi sekarang?")) return;

    setIsPresensiLoading(true);
    setNotice(null);
    const result = await kirimPresensiHadir();
    setIsPresensiLoading(false);
    setNotice({ success: result.success, text: result.message });

    if (result.success) {
      const userId = localStorage.getItem("user_id");
      if (userId) fetchJadwalHariIni(userId).then((data) => data && setJadwal(data));
    } else if (result.action === "isi_jadwal") {
      navigate("/jadwal");
    }
  };

  useEffect(() => {
    const userId = localStorage.getItem("user_id");
    setNamaSiswa(localStorage.getItem("nama") || "Siswa");
    setKelas(localStorage.getItem("kelas") || "Kelas belum diatur");

    if (userId) {
      fetchJadwalHariIni(userId).then((data) => {
        if (data) {
          setJadwal(data);
          setNamaGuru(data.nama_guru || "-");
        }
      });
      checkJadwal().then((result) => {
        if (result.success) navigate("/jadwal", { replace: true });
      });
    }

    fetchNamaGuru().then((name) => {
      if (name) setNamaGuru(name);
    });
  }, [navigate]);

  return (
    <main className="app-mobile-page">
      <header className="app-brand-header">
        <div className="app-brand-row">
          <img src={logo} alt="Logo E-Prajogo" className="app-brand-logo" />
          <div>
            <p className="app-brand-name">E-PRAJOGO</p>
            <p className="app-brand-school">SMK NEGERI GUDO</p>
          </div>
          <span className="ms-auto rounded-pill px-3 py-2 small fw-semibold" style={{ background: "#ffffff20", color: "#fff" }}>SISWA</span>
        </div>
        <h1 className="app-header-title">Presensi Siswa</h1>
        <p className="app-header-subtitle">{hariTanggal}</p>
      </header>

      <section className="app-content">
        <Card style={cardStyle} className="mb-3">
          <Card.Body className="d-flex align-items-center gap-3 p-3">
            <div className="rounded-circle d-flex align-items-center justify-content-center fw-bold text-primary" style={{ width: 48, height: 48, flex: "0 0 48px", background: "var(--app-soft-blue)" }}>
              {(namaSiswa || "S").trim().slice(0, 1).toUpperCase()}
            </div>
            <div className="min-w-0">
              <div className="fw-bold">{namaSiswa}</div>
              <small className="text-muted">{kelas}</small>
              <div className="small text-muted">Pembimbing: {namaGuru}</div>
            </div>
          </Card.Body>
        </Card>

        <h2 className="h6 fw-bold mb-2">Jadwal PKL hari ini</h2>
        <Card style={cardStyle} className="mb-3">
          <Card.Body className="p-3">
            <div className="d-flex justify-content-between align-items-center mb-3">
              <div className="d-flex align-items-center gap-2 fw-semibold"><BsCalendar3 className="text-primary" />{hariTanggal}</div>
              <Button variant="link" className="p-0 small text-decoration-none fw-semibold" onClick={() => navigate("/jadwal")}>Lihat jadwal</Button>
            </div>
            <div className="row g-2">
              <div className="col-6"><div className="rounded-3 p-3 h-100" style={{ background: "#eaf1ff" }}>
                <small className="text-muted d-flex align-items-center gap-1"><BsClock /> Masuk</small>
                <div className="fs-5 fw-bold text-primary mt-1">{jadwal?.jam_masuk || "—"}</div>
              </div></div>
              <div className="col-6"><div className="rounded-3 p-3 h-100" style={{ background: "#eef6ff" }}>
                <small className="text-muted d-flex align-items-center gap-1"><BsClock /> Pulang</small>
                <div className="fs-5 fw-bold text-primary mt-1">{jadwal?.jam_keluar || "—"}</div>
              </div></div>
            </div>
            <div className="d-flex gap-2 align-items-center small text-muted mt-3">
              <BsBuilding className="text-primary" />
              <span>{localStorage.getItem("tempat_pkl") || "Tempat PKL belum diatur"}</span>
            </div>
          </Card.Body>
        </Card>

        {notice && <div className={`alert ${notice.success ? "alert-success" : "alert-danger"} rounded-3 py-2 small`} role="status">{notice.text}</div>}

        <Card style={{ ...cardStyle, overflow: "hidden" }}>
          <Card.Body className="text-center px-4 py-4">
            <div className="rounded-circle mx-auto mb-3 d-flex align-items-center justify-content-center" style={{ width: 58, height: 58, color: "var(--app-blue)", background: "var(--app-soft-blue)" }}>
              <BsPersonBadge size={27} />
            </div>
            <h2 className="h5 fw-bold mb-1">Presensi hari ini</h2>
            <p className="small text-muted mb-3">Pastikan kamu berada di tempat PKL saat melakukan presensi.</p>
            <Button className="auth-submit w-100 d-flex justify-content-center align-items-center gap-2" disabled={!jadwal || isPresensiLoading} onClick={handlePresensi}>
              {isPresensiLoading ? <><Spinner size="sm" /> Mengirim presensi...</> : <><BsFingerprint size={20} /> Presensi Sekarang</>}
            </Button>
            {!jadwal && <Button variant="link" className="mt-2 text-decoration-none" onClick={() => navigate("/jadwal")}>Lengkapi jadwal presensi</Button>}
            {jadwal && <div className="d-flex justify-content-center align-items-center gap-2 small text-success mt-3"><BsCheckCircle /> Jadwal presensi tersedia</div>}
          </Card.Body>
        </Card>

        <Button variant="outline-primary" className="w-100 mt-3 py-2 rounded-3 fw-semibold" onClick={() => navigate("/izin")}>
          <BsHeartPulse className="me-2" />Ajukan izin / sakit
        </Button>
      </section>
      <BottomNavbar />
    </main>
  );
}

export default Dashboard;
